import { HEIGHT_BUTTON } from "../../../utils/constants";

export const MODAL_GALLERY_FETCH_MODE_URL = "url";
export const MODAL_GALLERY_FETCH_MODE_META_AD_LIBRARY = "metaAdLibrary";
export const MODAL_GALLERY_FETCH_MODE_COMPETITOR_ADS = "competitorAds";

export const COMPETITOR_ADS_COMPETITOR_FILTER_FIELD =
  "competitorAdsCompetitorFilter";

export const COMPETITOR_ADS_PLATFORM_FILTER_FIELD = "platform";

export const COMPETITOR_ADS_LOADING_TIME_MS = 60 * 1000;

export const META_AD_LIBRARY_COMPETITOR_FILTER_FIELD =
  COMPETITOR_ADS_COMPETITOR_FILTER_FIELD;

export const META_AD_LIBRARY_PLATFORM_FILTER_FIELD =
  COMPETITOR_ADS_PLATFORM_FILTER_FIELD;

export const META_AD_LIBRARY_LOADING_TIME_MS = COMPETITOR_ADS_LOADING_TIME_MS;

export const COMPETITOR_FILTER_BAR_SX = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  px: 4,
  pb: 2,
  width: "100%",
  maxWidth: 720,
};

export const COMPETITOR_FILTER_SELECT_WRAPPER_SX = {
  flex: 1,
  minWidth: 0,
};

export const COMPETITOR_PLATFORM_FILTER_SELECT_WRAPPER_SX = {
  flex: "0 0 200px",
  minWidth: 220,
  maxWidth: 220,
};

export const COMPETITOR_FILTER_SELECT_SX = {
  width: "100%",
  maxWidth: "100%",
  height: HEIGHT_BUTTON,
  minWidth: 0,
  "& .MuiFilledInput-root": {
    height: HEIGHT_BUTTON,
    minHeight: HEIGHT_BUTTON,
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    minHeight: "unset",
    py: 0,
    height: HEIGHT_BUTTON,
  },
};
